import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getallmembershiptypes } from '../store/slices/userSlice';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";
import Membershippaymentsmodal from './membershippaymentsmodal';
import { getallmembershippaymentsbydate } from '../store/slices/userSlice';
import { fetchtransactions } from '../services/dbService';
import axios from "axios";

function Paypaltransactionsbydate() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);  // Initialize as empty array, not true
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

  const [selected, setSelected] = useState(null);

  const [startdate, setStartdate] = useState(null);
  const [enddate, setEnddate] = useState(null);

  // Function to transform PayPal API response for the PaginatedTable
  const formatPaypalDataForTable = (transactions) => {
    try {
      return transactions.map(transaction => ({
        date: new Date(transaction?.transaction_info?.transaction_initiation_date || '').toLocaleDateString(),
        transaction_id: transaction?.transaction_info?.transaction_id || 'N/A',
        payer_email: transaction?.payer_info?.email_address || 'N/A',
        payer_name: transaction?.payer_info?.payer_name?.alternate_full_name || 'N/A',
        amount: `${transaction?.transaction_info?.transaction_amount?.value || '0.00'} ${transaction?.transaction_info?.transaction_amount?.currency_code || ''}`,
        fee_amount: `${transaction?.transaction_info?.fee_amount?.value || '0.00'} ${transaction?.transaction_info?.fee_amount?.currency_code || ''}`,
        status: transaction?.transaction_info?.transaction_status || 'Unknown',
        instrument_type: transaction?.transaction_info?.instrument_type || 'N/A',
        shipping_address: [
          transaction?.shipping_info?.address?.line1,
          transaction?.shipping_info?.address?.city,
          transaction?.shipping_info?.address?.state,
          transaction?.shipping_info?.address?.postal_code,
          transaction?.shipping_info?.address?.country_code,
        ].filter(Boolean).join(', ') || 'N/A',
      }));
    } catch (error) {
      console.error('Error formatting PayPal transactions:', error);
      return []; // Return empty array on failure to avoid crashing the UI
    }
  };
  
  const fetchData = async () => {
    setError(null);
    setLoading(true); // Set loading to true when fetching data
    try {
      //const response = await fetchtransactions(startdate, enddate);

      const response = await axios.get(`https://api.adyapeathusa.org/index.php/paypal/transactions`, {
        params: {
          start_date: startdate,
          end_date: enddate
        }
      });

      console.log('response',response.data)

      // Assuming response.data contains the PayPal API response directly
      if (response && response.data.transaction_details && Array.isArray(response.data.transaction_details)) {
        setData(formatPaypalDataForTable(response.data.transaction_details));
      } else {
        setData([]); // If no transaction_details or not an array, set to empty
      }
    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false); // Set loading to false after data is fetched or error occurs
    }
  };

  useEffect(() => {
    const initialize = () => {
      try {
        // You can fetch initial data here if needed
        setLoading(false); // Remove if loading should depend on another trigger
      } catch (error) {
        console.error("Error during initialization:", error);
        // Optionally show an error message or set error state
      }
    };
  
    initialize();
  }, []);
  
  const handleEdit = (item) => {
    try {
      setSelected(item);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error while editing item:", error);
      // Optionally show an error message or fallback logic
    }
  };
  

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">Paypal Transactions By Date</h4>

                      </div>
                    </div>
                    <div className="card-body">

                      <div className="d-flex flex-wrap align-items-center gap-3 my-3">
                        <div>
                          <label className="form-label mb-1">Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={startdate ? new Date(startdate).toISOString().split('T')[0] : ""}
                            onChange={(e) => {
                              const date = e.target.value;
                              const formatted = `${date}T00:00:00Z`;
                              setStartdate(formatted);
                            }}
                          />
                        </div>
                        <div>
                          <label className="form-label mb-1">End Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={enddate ? new Date(enddate).toISOString().split('T')[0] : ""}

                            onChange={(e) => {
                              const date = e.target.value;
                              const formatted = `${date}T23:59:59Z`;
                              setEnddate(formatted);
                            }}
                          />
                        </div>
                        <div className="align-self-end">
                          <button className="btn btn-primary" onClick={fetchData}>
                            Get Report
                          </button>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "date",
                                "transaction_id",
                                "payer_name",
                                "payer_email",
                                "amount",
                                "fee_amount",
                                "status",
                                "instrument_type",
                                "shipping_address"
                                // Add more columns as needed based on your `formatPaypalDataForTable` function
                              ]}
                              data={data}
                              onEdit={handleEdit}
                              showedit={false}
                              showstatus={false}

                            />
                          </div>
                        ) : (
                          <p>No data available for the selected date range.</p>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Paypaltransactionsbydate;